import { ICreateEvent } from '../../event/types';

export const EVENT_FORM_INITIAL_STATE: ICreateEvent = {
  title: '',
  description: '',
  desktop_cover: '',
  mobile_cover: '',
  tablet_cover: '',
};
